










































































import {Component, Vue} from 'vue-property-decorator';

@Component({})
export default class Assets extends Vue {

  private assets: any = {};

  created() {
    const req = require.context('../assets/', true, /\.(svg|png|webm|mp4)$/i)
    this.assets = req.keys()
      .map(file => file.substring(2).split('/'))
      .filter(file => file.length > 1) // filter out root files
      .reduce(
        (dirnames: any, [ dirname, file]) => {
          const fileArray = file.split('.');
          const extension = fileArray.pop();
          const filename = fileArray.join('.');
          
          dirnames[dirname] = dirnames[dirname] || {};
          dirnames[dirname][filename] = [...(dirnames[dirname][filename] || []), extension]
          return dirnames;
        }, {}
      );
  }

  getImageUrl(path: string) {
    return require(`@/assets/${path}`);
  }

}
